(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const getCartDrawer = () => document.querySelector('#cart-drawer');

const closeCartSheet = (sheet) => {
    if (!sheet) return;

    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
};

const openCartSheet = (sheet) => {
    if (!sheet) return;

    const drawer = getCartDrawer();

    drawer
        ?.querySelectorAll('.pl-cart-sheet.is-open')
        .forEach((openSheet) => {
            if (openSheet !== sheet) {
                closeCartSheet(openSheet);
            }
        });

    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');

    requestAnimationFrame(() => {
        const focusTarget = sheet.querySelector(
            'textarea, input, button:not([data-cart-sheet-close])'
        );

        focusTarget?.focus({
            preventScroll: true
        });
    });
};

document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-cart-sheet-open]');

    if (openButton) {
        const drawer = openButton.closest('#cart-drawer');
        if (!drawer) return;

        const name = openButton.dataset.cartSheetOpen;
        const sheet = drawer.querySelector(
            `[data-cart-sheet="${name}"]`
        );

        openCartSheet(sheet);
        return;
    }

    const closeButton = event.target.closest('[data-cart-sheet-close]');

    if (closeButton) {
        closeCartSheet(closeButton.closest('[data-cart-sheet]'));
    }
});

document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const drawer = getCartDrawer();
    const sheet = drawer?.querySelector('.pl-cart-sheet.is-open');

    if (sheet) {
        event.stopPropagation();
        closeCartSheet(sheet);
    }
});
  } catch(e) { console.error(e); }
})();

})();
